import { practiceConnectApi } from '../practiceConnectApi';
import CONSTANTS from '../../../../utils/constants';
import { ExistingEnrollmentsResponse } from './models';

export const getMyEnrollments = async (): Promise<ExistingEnrollmentsResponse> => {
  const response = await practiceConnectApi.get<ExistingEnrollmentsResponse>(`${CONSTANTS.PROJECT_CONNECT_API_BASE_URL}/v1/enrollment`);
  return response.data;
};
